import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.css']
})
export class ChatHeaderComponent {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() image: string = '';
  @Input() isOnline: boolean = false;
  @Input() status: string = '';
  @Input() showMenu: boolean = false;
  @Input() isGroup: boolean = false;
  @Input() totalMembers: number = 0;
  @Input() memberDisplayNames: string[] = [];
  @Input() showClickForInfo: boolean = false;
  @Input() isExited: boolean = false;
  @Input() hasMessages: boolean = false;
  @Input() isAdmin: boolean = false;
  /** The Admin department: only it deletes a chat for everyone (3 Nov 2026). */
  @Input() isLinkAdmin: boolean = false;
  @Input() typingUsers: Array<{ userId: string; userName: string }> = [];
  @Input() showSearchBackButton: boolean = false;
  // e.g. "Waiting for network…" — overrides status/typing while the chat is disconnected
  @Input() connectionStatus: string = '';

  @Output() back = new EventEmitter<void>();
  @Output() searchBack = new EventEmitter<void>();
  @Output() toggleMenu = new EventEmitter<void>();
  @Output() clearChat = new EventEmitter<void>();
  @Output() exitGroup = new EventEmitter<void>();
  @Output() deleteGroup = new EventEmitter<void>();
  @Output() removeGroup = new EventEmitter<void>();
  @Output() openInfo = new EventEmitter<void>();
  @Output() starredClick = new EventEmitter<void>();
  @Output() quickSearch = new EventEmitter<void>();
  @Output() exportChat = new EventEmitter<'txt' | 'json'>();

  onQuickSearch(event: Event) {
    event.stopPropagation();
    this.quickSearch.emit();
  }

  onBack(event: Event) {
    event.stopPropagation();
    this.back.emit();
  }

  onSearchBack(event: Event) {
    event.stopPropagation();
    this.searchBack.emit();
  }

  onToggleMenu(event: Event) {
    event.stopPropagation();
    this.toggleMenu.emit();
  }

  onClearChat(event: Event) {
    event.stopPropagation();
    this.clearChat.emit();
  }

  onExitGroup(event: Event) {
    event.stopPropagation();
    this.exitGroup.emit();
  }

  onDeleteGroup(event: Event) {
    event.stopPropagation();
    this.deleteGroup.emit();
  }

  onRemoveGroup(event: Event) {
    event.stopPropagation();
    this.removeGroup.emit();
  }

  onOpenInfo() {
    if (this.showClickForInfo) {
      this.openInfo.emit();
    }
  }

  onStarredClick(event: Event) {
    event.stopPropagation();
    this.starredClick.emit();
  }

  onExportChat(format: 'txt' | 'json', event: Event) {
    event.stopPropagation();
    this.exportChat.emit(format);
  }

  get typingText(): string {
    if (this.typingUsers.length === 0) return '';

    if (this.typingUsers.length === 1) {
      return `${this.typingUsers[0].userName} is typing...`;
    } else if (this.typingUsers.length === 2) {
      return `${this.typingUsers[0].userName} and ${this.typingUsers[1].userName} are typing...`;
    } else {
      return `${this.typingUsers[0].userName} and ${this.typingUsers.length - 1} others are typing...`;
    }
  }

  handleProfileImageError(event: any) {
    event.target.src = this.isGroup ? 'assets/group_chat.png' : 'assets/user-icon.png';
  }
}
